export const FONTS = {
    cor: {
        t7: {
            fontFamily: "cormorant",
            fontSize: "16px",
            fontWeight: 700,
            lineHeight: "1.2",
        },
        s7: {
            fontFamily: "cormorant",
            fontSize: "20px",
            fontWeight: 700,
            lineHeight: "1.2",
        },
        m7: {
            fontFamily: "cormorant",
            fontSize: "24px",
            fontWeight: 700,
            lineHeight: "1.2",
        },
        l7: {
            fontFamily: "cormorant",
            fontSize: "32px",
            fontWeight: 700,
            lineHeight: "1.2",
        },
        b7: {
            fontFamily: "cormorant",
            fontSize: "48px",
            fontWeight: 700,
            lineHeight: "1.2",
        },
        h7: {
            fontFamily: "cormorant",
            fontSize: "54px",
            fontWeight: 700,
            lineHeight: "1.2",
        },
    },
    noto: {
        s5: {
            fontFamily: "Noto Serif KR",
            fontSize: "16px",
            fontWeight: 500,
            lineHeight: "1.5",
        },
        m5: {
            fontFamily: "Noto Serif KR",
            fontSize: "20px",
            fontWeight: 500,
            lineHeight: "1.5",
        },
        l5: {
            fontFamily: "Noto Serif KR",
            fontSize: "24px",
            fontWeight: 500,
            lineHeight: "1.5",
        },
        b5: {
            fontFamily: "Noto Serif KR",
            fontSize: "32px",
            fontWeight: 500,
            lineHeight: "1.5",
        },
        h5: {
            fontFamily: "Noto Serif KR",
            fontSize: "32px",
            fontWeight: 700,
            lineHeight: "1.5",
        },
    },
    pre: {
        n3: {
            fontFamily: "Pretendard Variable",
            fontSize: "14px",
            fontWeight: 300,
            lineHeight: "1.5",
        },
        t3: {
            fontFamily: "Pretendard Variable",
            fontSize: "16px",
            fontWeight: 300,
            lineHeight: "1.5",
        },
        n7: {
            fontFamily: "Pretendard Variable",
            fontSize: "14px",
            fontWeight: 700,
            lineHeight: "1.5",
        },
        s5: {
            fontFamily: "Pretendard Variable",
            fontSize: "16px",
            fontWeight: 500,
            lineHeight: "1.5",
        },
        b5: {
            fontFamily: "Pretendard Variable",
            fontSize: "24px",
            fontWeight: 500,
            lineHeight: "1.5",
        },
        s7: {
            fontFamily: "Pretendard Variable",
            fontSize: "16px",
            fontWeight: 700,
            lineHeight: "1.5",
        },
        m7: {
            fontFamily: "Pretendard Variable",
            fontSize: "20px",
            fontWeight: 700,
            lineHeight: "1.5",
        },
    },
} as const;
